module.exports = __webpack_public_path__ + "img/IMG-20180803-WA0016.91d98f5b.jpg";